import { Component, OnInit } from '@angular/core';
import { FormBuilderBasicInputComponentModel } from '../../models/form-builder-basic-input-component-model';

@Component({
  selector: 'tf-core-fb-basic-input-text-input',
  templateUrl: './fb-basic-input-text-input.component.html',
  styleUrls: ['./fb-basic-input-text-input.component.css']
})
export class FbCoreBasicInputTextInputComponent extends FormBuilderBasicInputComponentModel implements OnInit {
    public data = {
        component: null,
        editorData: '',
        editorActive: false,
        hasChanges: false,
        viewType: 'default',
        toggleTooltips: false,
        formGroup: null,
        controlName: ''
    };

    constructor(
    ) {
        super();
    }

    ngOnInit(): void {
        super.init();
    }

    get subtype(): string {
        return this.data.component.subtype;
    }

    get characterCount(): number {
        return this.data.component.characterCount;
    }

}
